import {
  paymentBusinessBg,
  paymentEnterpriseBg,
  paymentUnlicensedBg,
  licenseEnterpriseBg,
} from '../assets';

import color from './color';

const license = {
  UNLICENSED: 'Unlicensed',
  PROFESSIONAL: 'Professional',
  BUSINESS: 'Business',
  ENTERPRISE: 'Enterprise',
};

export const typeList = [
  {
    value: '56f164ea-efac-4fd4-906f-f0b4240b13cb',
    image: paymentUnlicensedBg,
  },
  {
    value: '309fedbb-cb5c-430e-b1c9-a897a4687739',
    image: paymentBusinessBg,
  },
  {
    value: '9bb87008-c7e8-4fcf-8955-6b6bb0bb3d31',
    image: paymentEnterpriseBg,
  },
];

export default license;

export const licenseStatus = {
  ACTIVE: 1,
  INACTIVE: 2,
};

export const renewalType = [
  {
    value: 1,
    month: 1,
    label: 'Monthly',
    period: 'month',
    attribute: 'monthly_price',
    teamLicenseAttr: 'monthly_price',
  },
  {
    value: 2,
    label: 'Annually',
    month: 12,
    period: '1 year',
    attribute: 'annual_price',
    teamLicenseAttr: 'annual_price',
  },
  {
    value: 3,
    month: 24,
    label: 'Biennially',
    period: '2 years',
    attribute: 'biennial_price',
    teamLicenseAttr: 'biennial_price',
  },
];

export const licenseID = {
  personal: {
    id: '56f164ea-efac-4fd4-906f-f0b4240b13cb',
    name: 'Personal',
    image: null,
    primaryColor: color.orange1,
    secondaryColor: color.grey5,
    shadowColor: 'rgba(255, 120, 41, 44%)',
  },
  business: {
    id: '309fedbb-cb5c-430e-b1c9-a897a4687739',
    name: 'Business',
    image: null,
    primaryColor: '#4A93FF',
    secondaryColor: color.grey5,
    shadowColor: 'rgba(74, 147, 255, 44%)',
  },
  enterprise: {
    id: '9bb87008-c7e8-4fcf-8955-6b6bb0bb3d31',
    name: 'Enterprise',
    image: licenseEnterpriseBg,
    primaryColor: '#FFFFFF',
    secondaryColor: color.black1,
    shadowColor: 'transparent',
  },
};

export const typeTeam = {
  PERSONAL: {
    value: 1,
    title: 'Personal',
  },
  TEAM: {
    value: 2,
    title: 'Team',
  },
};

export const userLicenseTitle = {
  [typeTeam.PERSONAL.value]: typeTeam.PERSONAL.title,
  [typeTeam.TEAM.value]: typeTeam.TEAM.title,
};

export const emailContact = 'license@alphaveritas.app';
